import React, { useEffect, useRef, useState } from "react";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";

import {
  MDBAlert,
  MDBBtn,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBSelect,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";

import { useLocation, useNavigate } from "react-router";
import { getACDGroups } from "../apiclients/streamsapi_bridge";
import PopupLoader from "./popups/PopupLoader";
import AddACDGroup from "./popups/acd/AddACDGroup";
import DeleteACDQueue from "./popups/acd/DeleteACDGroup";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "./popups/PopupLoaderNew";

function ACDQueues(props) {
  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);

  const [acdActive, setAcdActive] = useState("acdqueues");
  const [fillActive, setFillActive] = useState("tab1");
  const navigate = useNavigate();
  const location = useLocation();
  const [isloading, setIsloading] = useState(false);
  const [acdGroups, setACDGroups] = useState([]);
  const [addACDGroup, setAddACDGroup] = useState(location.state ? location.state.openadd : false);
  const [deleteACDGroup, setDeleteACDGroup] = useState(false);
  const togglePopup = () => setAddACDGroup(!addACDGroup);
  const dtogglePopup = () => setDeleteACDGroup(!deleteACDGroup);
  const [internalError, setInternalError] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState();
  const addACDGrpRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  function handleClick() {
    addACDGrpRef.current.click();
  }





  const handleFillClick = (value) => {
    if (value === fillActive) {
      return;
    }

    setFillActive(value);
  };
  const handleAcdClick = (value) => {
    if (value === acdActive) {
      return;
    }

    setAcdActive(value);
  };

  const [verticalActive, setVerticalActive] = useState("tab1");
  const [agent, setAgent] = useState("tab1");

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }
    setVerticalActive(value);
  };


  async function fetchACDGroupData() {
    try {
      sessionStorage.setItem("current_link", "acdQueues");
      setIsloading(true);
      setInternalError(false);
      const response = await getACDGroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      const rawData = await response.json();
      if (response.status === 200) {
        setACDGroups(rawData?.groups ?? []);
      } else if (response.status === 500) {
        setInternalError(true);
      } else {
        navigate("/");
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
      setIsloading(false);
    }

  }

  useEffect(() => {
    fetchACDGroupData();
  }, []);

  let proccessdRows = [];
  acdGroups.map((group) => {

    proccessdRows.push({
      acdInfo: group,
      name: group.title,
      extension: group.extensions,
      phnumber: group.phnumber ? group.phnumber : 'N/A',
      delete: (
        // <a
        //   style={{ zIndex: 99996 }}
        //   href="#"
        //   onClick={(e) => deletethisGroup(e, group.code)}
        //   target="_new"
        // >
        //   <MDBIcon fas icon="times" className="green ms-3" title="Remove" />
        // </a>
        <div className="d-flex align-items-center justify-content-center">
          <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deletethisGroup(e, group.code)}>
            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
          </div>
        </div>
      )
    });
  });

  const finalData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Extension", field: "extension", sort: true },
      { label: "Numbers", field: "phnumber" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: proccessdRows,
  };

  function deletethisGroup(evntData, groupId) {
    evntData.preventDefault();
    evntData.stopPropagation();
    setSelectedGroupId(groupId)
    setDeleteACDGroup(true)
  }

  function showThisInfo(tdata) {
    navigate("/acdqueuessettings", {
      state: tdata.acdInfo,
    });
  }


  const handleAgentClick = (value) => {
    if (value === agent) {
      return;
    }

    setAgent(value);
  };

  const actionData = {
    columns: [
      { label: "Name", field: "name" },
      { label: "Extension", field: "position" },
      {
        label: "Agent Status - Login or Logout of All Assigned Queues",
        field: "checkbox",
        sort: false,
      },
      { label: "Login to Persistent Queues", field: "contact", sort: false },
      { label: "Remove", field: "office" },
    ],
    rows: [
      {
        name: "All Agents in the List",
        position: "",
        checkbox: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <MDBIcon fas icon="times" color="primary" title="Remove" />,
      },
      {
        name: "Nick Leyendecker",
        position: "3755",
        checkbox: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <MDBIcon fas icon="times" color="primary" title="Remove" />,
      },
      {
        name: "Tatyana Fitzpatrick",
        position: "Regional Director",
        checkbox: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <MDBIcon fas icon="times" color="primary" title="Remove" />,
      },
    ],
  };

  const actionData2 = {
    columns: [
      { label: "Name", field: "name", className: "first-column" },
      { label: "Extension", field: "position" },
      // {
      //     label: "Agent Status - Login or Logout of All Assigned Queues",
      //     field: "checkbox",
      //     sort: false,
      // },
      { label: "Login of Logout All Agents", field: "contact", sort: false },
      { label: "Remove", field: "office" },
    ],
    rows: [
      {
        name: "All Agents in the List",
        position: "",
        // checkbox: (
        // <label className="switch">
        //     <input className="form-control" type="checkbox" />
        //     <span className="slider round"></span>
        // </label>
        // ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <span title="Remove"><i className="fas fa-xmark text-primary"></i></span>,
        style: { borderBottom: "2px solid #8bc500 !important" },
      },
      {
        name: "Nick Leyendecker",
        position: "3755",
        // checkbox: (
        // <label className="switch">
        //     <input className="form-control" type="checkbox" />
        //     <span className="slider round"></span>
        // </label>
        // ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <span title="Remove"><i className="fas fa-xmark text-primary"></i></span>,
      },
      {
        name: "Tatyana Fitzpatrick",
        position: "Regional Director",
        // checkbox: (
        // <label className="switch">
        //     <input className="form-control" type="checkbox" />
        //     <span className="slider round"></span>
        // </label>
        // ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <span title="Remove"><i className="fas fa-xmark text-primary"></i></span>,
      },
    ],
  };

  const basicData = {
    columns: ["Name", "Extension", "Set Schedule"],
    rows: [
      [
        "Nick Leyendecker",
        "3755",
        "Monday(9:00 to 6:00 PM), Tuesday (9:00 AM to 6:00 PM), Wednesday(9:00 AM to 6:00 PM) Thrusday(9:00 AM to 6:00 PM), Friday(9:00 AM to 6:00 PM)	",
      ],
    ],
  };

  // const [AddACDQueue, setAddACDQueue] = useState(false);
  // const toggleShow9 = () => setAddACDQueue(!AddACDQueue);

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={89}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header px-0">
                    <h5 className="fw-600">{t("ACDQueues")}</h5>
                  </div>
                  <div className="card-body px-0">

                    <MDBTabs className="mt-2">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("acdqueues")}
                          active={acdActive === "acdqueues"}
                        >
                          {t("ACDQueues")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("generalsettings")}
                          active={acdActive === "generalsettings"}
                        >
                          {t("GeneralSettings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("bulkloginlogout")}
                          active={acdActive === "bulkloginlogout"}
                        >
                          {t("BulkLoginLogout")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("scheduledloginlogout")}
                          active={acdActive === "scheduledloginlogout"}
                        >
                          {t("ScheduledLoginLogout")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>
                    <MDBTabsContent>
                      <MDBTabsPane open={acdActive === "acdqueues"}>
                        {/* ACD Queues content */}
                        {/* <div className="d-flex justify-content-between flex-wrap mx-2">
                          <div className="btn-width-100 w-30">
                            {/* <div className="form-outline">
                              <MDBInput className="mb-4"
                                type="text"
                                id="datatable-search-input"
                                label={t("search")}
                              />
                            </div>  
                      </div>
                  </div> */}
                        <div className="acdDatatable">
                          <div className="actionbar mt-6px">
                            <MDBBtn onClick={togglePopup}>
                              <MDBIcon fas icon="plus" size="sm" /> {t("add_ACDQueue")}
                            </MDBBtn>
                            {/* <MDBBtn className="ms-3" href="/acdqueuessettings">
                              {t("ACDQueuesSettings")}
                            </MDBBtn> */}
                          </div>
                          <MDBDatatable className="actioncolumn"
                            onRowClick={(event, rowData) => {
                              showThisInfo(event);
                            }}
                            // key={searchValue}
                            search
                            fixedHeader
                            sortField="Name"
                            entries={50}
                            // maxHeight="70vh"
                            multi
                            // selectable
                            data={finalData}
                          />
                        </div>
                      </MDBTabsPane>


                      <MDBTabsPane open={acdActive === "generalsettings"}>
                        {/* General Settings content */}
                        <div className="row mt-1">
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <MDBTabs className="flex-column text-center mt-2">
                              <MDBTabsItem>
                                <MDBTabsLink
                                  className=""
                                  href="#generals"
                                  onClick={() => handleVerticalClick("tab1")}
                                  active={verticalActive === "tab1"}
                                >
                                  {t("general")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                              <MDBTabsItem>
                                <MDBTabsLink
                                  className=""
                                  href="#routings"
                                  onClick={() => handleVerticalClick("tab2")}
                                  active={verticalActive === "tab2"}
                                >
                                  {t("UnavailableReasons")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                              <MDBTabsItem>
                                <MDBTabsLink
                                  className=""
                                  href="#voicemails"
                                  onClick={() => handleVerticalClick("tab3")}
                                  active={verticalActive === "tab3"}
                                >
                                  {t("DispositionComments")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                            </MDBTabs>
                          </MDBCol>

                          <MDBCol
                            size="12"
                            md="10"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <div className="vtabHeight pr-5">
                              <div className="huntgroup">
                                <div
                                  className="general-settings"
                                  id="generals"
                                > {t("general")}
                                </div>
                                <div className="add-numbermain ">
                                  <div className="tel-numbers">
                                    {t("PurchaseACDQueues")}
                                  </div>
                                  <div
                                    className="add-number floatRight"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addnumber"
                                  >
                                    <MDBIcon fas icon="plus" size="sm" /> {t("PurchaseQueues")}
                                  </div>
                                </div>
                                <div>
                                  <span className="phrecording">
                                    {t("PurchaseQueuestxt")}
                                  </span>
                                </div>
                                <div className="left-table-aligniment mt-sm-10">
                                  <div className="sub-details">
                                    <div>
                                      <label>{t("Included")}</label> 10
                                    </div>
                                    <div>
                                      <label>{t("Purchased")}</label> 10
                                    </div>
                                    <div>
                                      <label>{t("Used")}</label> 10
                                    </div>
                                    <div>
                                      <label>{t("Included")}</label> 10
                                    </div>
                                  </div>
                                </div>

                                <div className=" mt-3">
                                  <div className="">
                                    <div>
                                      <div className="tel-numbers">
                                        {t("AgentIdleTimer")}
                                      </div>
                                      <span className="phrecording">
                                        {t("AgentIdleTimertxt")}
                                      </span>
                                    </div>
                                    <div className="phoneselect floatRight">
                                      <MDBSelect
                                        data={[
                                          { text: "All Queues", value: 1 },
                                          { text: "Two", value: 2 },
                                          { text: "Three", value: 3 },
                                          { text: "Four", value: 4 },
                                          { text: "Five", value: 5 },
                                          { text: "Six", value: 6 },
                                          { text: "Seven", value: 7 },
                                          { text: "Eight", value: 8 },
                                        ]}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="routing-border mt-2"></div>
                                <div
                                  className="general-settings float-start"
                                  id="routings"
                                >
                                  {t("UnavailableReasons")}
                                </div>
                                <div className="add-numbermain float-end">
                                  <div
                                    className="add-number floatRight"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addnumber"
                                  >
                                    <MDBIcon fas icon="plus" size="sm" /> {t("AddReason")}
                                  </div>
                                </div>
                                <MDBTable>
                                  <MDBTableHead>
                                    <tr>
                                      <th scope="col" style={{ width: "70%" }}>
                                        {t("Reason")}
                                      </th>
                                      <th
                                        scope="col"
                                        className="text-end"
                                        style={{ width: "15%" }}
                                      >
                                        {t("Active")}
                                      </th>
                                      <th
                                        scope="col"
                                        className="text-end"
                                        style={{ width: "15%" }}
                                      >
                                        {t("Remove")}
                                      </th>
                                    </tr>
                                  </MDBTableHead>
                                  <MDBTableBody>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Be Right Back"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Busy"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Meeting"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Not At My Desk"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Lunch"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Project"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Rest Room"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Training"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                  </MDBTableBody>
                                </MDBTable>


                                <div className="routing-border mt-2"></div>
                                <div
                                  className="general-settings float-start"
                                  id="voicemails"
                                >
                                  {t("DispositionComments")}
                                </div>
                                <div className="add-numbermain float-end">
                                  <div
                                    className="add-number floatRight"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addnumber"
                                  >
                                    <MDBIcon fas icon="plus" size="sm" /> {t("AddComments")}
                                  </div>
                                </div>
                                <MDBTable>
                                  <MDBTableHead>
                                    <tr>
                                      <th scope="col" style={{ width: "70%" }}>
                                        {t("Reason")}
                                      </th>
                                      <th
                                        scope="col"
                                        className="text-end"
                                        style={{ width: "15%" }}
                                      >
                                        {t("Active")}
                                      </th>
                                      <th
                                        scope="col"
                                        className="text-end"
                                        style={{ width: "15%" }}
                                      >
                                        {t("Remove")}
                                      </th>
                                    </tr>
                                  </MDBTableHead>
                                  <MDBTableBody>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Call Back Tomorrow"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Follow Up Needed"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" className="me-3" color="primary" title="Remove" />
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">
                                        <input
                                          type="text"
                                          className="input-group-text"
                                          id="input-box"
                                          placeholder="Issue Resloved"
                                          disabled=""
                                        />
                                      </th>
                                      <td className="text-end">
                                        <label className="switch">
                                          <input className="form-control" type="checkbox" />
                                          <span className="slider round"></span>
                                        </label>
                                      </td>
                                      <td className="text-end">
                                        <MDBIcon fas icon="times" title="Remove" />
                                      </td>
                                    </tr>
                                  </MDBTableBody>
                                </MDBTable>
                              </div>
                            </div>
                          </MDBCol>
                        </div>
                      </MDBTabsPane>
                      <MDBTabsPane open={acdActive === "bulkloginlogout"}>
                        {/* Bulk Login or Logout content */}

                        {/* Agent Tabs */}
                        <MDBTabs className="mb-3">
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleFillClick("tab1")}
                              active={fillActive === "tab1"}
                            >
                              {t("Agents")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleFillClick("tab2")}
                              active={fillActive === "tab2"}
                            >
                              {t("ACDQueues")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                        </MDBTabs>
                        <MDBTabsContent>
                          <MDBTabsPane open={fillActive === "tab1"}>
                            <div className="mx-3">
                              {/* Agents content */}
                              {/* <div>
                                <div>
                                  <div className="form-outline">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="datatable-search-input"
                                      value=""
                                    />
                                    <label
                                      className="form-label z-index-1"
                                      for="datatable-search-input"
                                    >
                                      {t("search")}
                                    </label>
                                    <div className="form-notch">
                                      <div className="form-notch-leading"></div>
                                      <div className="form-notch-middle"></div>
                                      <div className="form-notch-trailing"></div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}

                              <div className="bulkloginOutDatatable">
                                <div class="actionbar"></div>
                                <MDBDatatable sortField="Name" className="actioncolumn"
                                  search hover data={actionData} />
                              </div>
                            </div>
                          </MDBTabsPane>
                          <MDBTabsPane open={fillActive === "tab2"}>
                            <div className="mx-3">
                              {/* Agents content */}
                              {/* <div className="btn-width-100 w-30 margin-end-10">
                                <div className="form-outline">
                                  <div className="form-outline">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="datatable-search-input"
                                      value=""
                                    />
                                    <label
                                      className="form-label"
                                      for="datatable-search-input"
                                    >
                                      {t("search")}
                                    </label>
                                    <div className="form-notch">
                                      <div className="form-notch-leading"></div>
                                      <div className="form-notch-middle"></div>
                                      <div className="form-notch-trailing"></div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              <div className="bulkloginOutDatatable">
                                <div class="actionbar"></div>
                                <MDBDatatable sortField="Name" search hover data={actionData2} className="actioncolumn" />
                              </div>
                            </div>
                          </MDBTabsPane>
                        </MDBTabsContent>
                        {/* Agent Content */}
                      </MDBTabsPane>
                      <MDBTabsPane open={acdActive === "scheduledloginlogout"}>
                        {/* Scheduled Login and Logout content */}
                        {/* <div className="mx-3">
                          <div className="btn-width-100 w-30 margin-end-10">
                            <div className="form-outline">
                              <div className="form-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="datatable-search-input"
                                  value=""
                                />
                                <label
                                  className="form-label"
                                  for="datatable-search-input"
                                >
                                  {t("search")}
                                </label>
                                <div className="form-notch">
                                  <div className="form-notch-leading"></div>
                                  <div className="form-notch-middle"></div>
                                  <div className="form-notch-trailing"></div>
                                </div>
                              </div>
                            </div>
                        </div>
                          </div> */}
                        <div className="scheduleloginOutDatatable">
                          <MDBDatatable sortField="Name" data={basicData} />
                        </div>
                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                </div>
              </section>
            </>
          }
        />

        {
          addACDGroup && (
            <PopupLoaderNew
              title={"Add ACD Queue"}
              content={<AddACDGroup 
                onClose={togglePopup}
                ref={addACDGrpRef}
                setIsloading={setisLoading}
                />}
              onShow={setAddACDGroup}
              onClose={togglePopup}
              onSave={handleClick}
              isloading={isLoading}
              flag={1}
            />
          )
        }
        {
          deleteACDGroup && (
            <PopupLoaderNew
              title={"Delete Hunt Group"}
              content={<DeleteACDQueue 
                groupId={selectedGroupId} 
                onClose={dtogglePopup}
                ref={addACDGrpRef}
                setIsloading={setisLoading}
                />}
              onShow={setDeleteACDGroup}
              onClose={dtogglePopup}
              onSave={handleClick}
              isloading={isLoading}
              flag={4}
            />
          )
        }

        {
          isloading && (
            <>
              <div className="loadingclass">
                <MDBBtn disabled>
                  <MDBSpinner
                    size="sm"
                    role="status"
                    tag="span"
                    className="me-2"
                  />
                  Loading...
                </MDBBtn>
              </div>
            </>
          )
        }
        {
          internalError && (<MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={3000}
          >Internal Server Error</MDBAlert>)
        }
        {/* <Footer /> */}
        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Remove
        </Tooltip>
      </>
    </React.Fragment >
  );
}

export default ACDQueues;
